"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignColumns = assignColumns;
function assignColumns(blocks, edges) {
    const deg = new Map();
    const outDeg = new Map();
    const inDeg = new Map();
    for (const e of edges) {
        deg.set(e.a, (deg.get(e.a) ?? 0) + 1);
        deg.set(e.b, (deg.get(e.b) ?? 0) + 1);
        if (e.fwd && !e.back) {
            outDeg.set(e.a, (outDeg.get(e.a) ?? 0) + 1);
            inDeg.set(e.b, (inDeg.get(e.b) ?? 0) + 1);
        }
        if (e.back && !e.fwd) {
            outDeg.set(e.b, (outDeg.get(e.b) ?? 0) + 1);
            inDeg.set(e.a, (inDeg.get(e.a) ?? 0) + 1);
        }
    }
    const used = blocks.filter((b) => deg.has(b.id));
    const hub = [...used].filter((b) => b.kind !== 'power').sort((x, y) => (deg.get(y.id) ?? 0) - (deg.get(x.id) ?? 0))[0] ?? null;
    const powerIds = new Set(used.filter((b) => b.kind === 'power').map((b) => b.id));
    const railAdj = new Map();
    for (const e of edges) {
        if (e.kind !== 'rail') {
            continue;
        }
        const s = e.fwd && !e.back ? e.a
            : e.back && !e.fwd ? e.b
                : null;
        const t = e.fwd && !e.back ? e.b
            : e.back && !e.fwd ? e.a
                : null;
        if (s !== null && t !== null && powerIds.has(s) && powerIds.has(t)) {
            const list = railAdj.get(s) ?? [];
            list.push(t);
            railAdj.set(s, list);
        }
    }
    const down = new Map();
    const dfs = (id, stack) => {
        const memo = down.get(id);
        if (memo !== undefined) {
            return memo;
        }
        if (stack.has(id)) {
            return 0;
        }
        stack.add(id);
        const r = 1 + Math.max(-1, ...(railAdj.get(id) ?? []).map((t) => dfs(t, stack)));
        stack.delete(id);
        down.set(id, r);
        return r;
    };
    for (const id of powerIds) {
        dfs(id, new Set());
    }
    const maxDown = Math.max(0, ...[...powerIds].map((i) => down.get(i) ?? 0));
    const depth = new Map();
    for (const id of powerIds) {
        depth.set(id, maxDown - (down.get(id) ?? 0));
    }
    const powerCols = powerIds.size > 0 ? Math.max(...[...powerIds].map((i) => depth.get(i) ?? 0)) + 1 : 0;
    const col = new Map();
    for (const b of used) {
        if (hub !== null && b.id === hub.id) {
            col.set(b.id, 1 + powerCols);
        }
        else if (b.kind === 'power') {
            col.set(b.id, 1 + (depth.get(b.id) ?? 0));
        }
        else if (b.kind === 'connector') {
            col.set(b.id, (outDeg.get(b.id) ?? 0) > (inDeg.get(b.id) ?? 0) ? 0 : powerCols + 3);
        }
        else if (b.kind === 'processor') {
            col.set(b.id, 1 + powerCols);
        }
        else {
            col.set(b.id, 2 + powerCols);
        }
    }
    const usedCols = [...new Set(col.values())].sort((a, b) => a - b);
    const remap = new Map(usedCols.map((c, i) => [c, i]));
    for (const [id, c] of col) {
        col.set(id, remap.get(c) ?? 0);
    }
    return { used, col, nCols: usedCols.length, hub: hub === null ? null : hub.id };
}
//# sourceMappingURL=assign-columns.js.map